import { supabase } from "../supabaseClient";

async function getTagPendingData(isApproved, userId = null) {
  if (userId === null) {
    let { data, error, count } = await supabase
      .from("CRM")
      .select("*", { count: "exact" })
      .eq("isTagApprove", isApproved)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  } else {
    let { data, error, count } = await supabase
      .from("CRM")
      .select("*", { count: "exact" })
      .eq("isTagApprove", isApproved)
      .eq("requestPendingWith", userId)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  }
}

async function getTagApprovedData(
  isTagApproved,
  isChangeableValue,
  isApproved,
  isRejectChanges,
  userId = null
) {
  if (userId === null) {
    let { data, error, count } = await supabase
      .from("CRM")
      .select("*", { count: "exact" })
      .eq("isApproved", isApproved)
      .eq("isTagApprove", isTagApproved)
      .eq("isChangeableValue", isChangeableValue)
      .eq("isRejectChanges", isRejectChanges)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  } else {
    let { data, error, count } = await supabase
      .from("CRM")
      .select("*", { count: "exact" })
      .eq("isApproved", isApproved)
      .eq("isTagApprove", isTagApproved)
      .eq("isChangeableValue", isChangeableValue)
      .eq("isRejectChanges", isRejectChanges)
      .eq("requestPendingWith", userId)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  }
}

async function getChangePlanData(
  isTagApproved,
  isChangeableValue,
  isApproved,
  isRejectChanges,
  userId = null
) {
  if (userId === null) {
    let { data, error, count } = await supabase
      .from("CRM")
      .select("*", { count: "exact" })
      .eq("isApproved", isApproved)
      .eq("isTagApprove", isTagApproved)
      .eq("isChangeableValue", isChangeableValue)
      .eq("isRejectChanges", isRejectChanges)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  } else {
    let { data, error, count } = await supabase
      .from("CRM")
      .select("*", { count: "exact" })
      .eq("isApproved", isApproved)
      .eq("isTagApprove", isTagApproved)
      .eq("isChangeableValue", isChangeableValue)
      .eq("isRejectChanges", isRejectChanges)
      .eq("requestPendingWith", userId)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  }
}

async function getCancellationData(status, leadConfirmation, userId = null) {
  if (userId === null) {
    let { data, error, count } = await supabase
      .from("CancelUnitRequests")
      .select("*", { count: "exact" })
      .eq("status", status)
      .eq("leadConfirmation", leadConfirmation)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  } else {
    let { data, error, count } = await supabase
      .from("CancelUnitRequests")
      .select("*", { count: "exact" })
      .eq("status", status)
      .eq("leadConfirmation", leadConfirmation)
      .eq("requestPendingWithUserId", userId)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  }
}

async function getCancellationRepriceData(
  status,
  unitPriceAlreadyUpdated,
  userId = null
) {
  if (userId === null) {
    let { data, error, count } = await supabase
      .from("CancelUnitRequests")
      .select("*", { count: "exact" })
      .eq("status", status)
      .eq("unitPriceAlreadyUpdated", unitPriceAlreadyUpdated)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  } else {
    let { data, error, count } = await supabase
      .from("CancelUnitRequests")
      .select("*", { count: "exact" })
      .eq("status", status)
      .eq("unitPriceAlreadyUpdated", unitPriceAlreadyUpdated)
      .eq("requestPendingWithUserId", userId)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  }
}

async function getChangeUnitData(status, userId = null) {
  if (userId === null) {
    let { data, error, count } = await supabase
      .from("ChangeUnitRequests")
      .select("*", { count: "exact" })
      .eq("status", status)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  } else {
    let { data, error, count } = await supabase
      .from("ChangeUnitRequests")
      .select("*", { count: "exact" })
      .eq("status", status)
      .eq("requestPendingWithUserId", userId)
      .order("last_updated_at", { ascending: false });
    if (data) return { data, count };
    else throw error;
  }
}

async function getChangeUnitRepriceData(status,unitPriceAlreadyUpdated, userId = null) {
    if (userId === null) {
      let { data, error, count } = await supabase
        .from("ChangeUnitRequests")
        .select("*", { count: "exact" })
        .eq("unitPriceAlreadyUpdated",unitPriceAlreadyUpdated)
        .order("last_updated_at", { ascending: false });
      if (data) return { data, count };
      else throw error;
    } else {
      let { data, error, count } = await supabase
        .from("ChangeUnitRequests")
        .select("*", { count: "exact" })
        .eq("unitPriceAlreadyUpdated",unitPriceAlreadyUpdated)
        .eq("requestPendingWithUserId", userId)
        .order("last_updated_at", { ascending: false });
      if (data) return { data, count };
      else throw error;
    }
  }

export {
  getTagPendingData,
  getTagApprovedData,
  getChangePlanData,
  getCancellationData,
  getCancellationRepriceData,
  getChangeUnitData,
  getChangeUnitRepriceData
};
